import { requestService } from '../helpers/request.service';

export const dropdownService = {
    getApprovalStatus,
    getPartners
}

function getApprovalStatus(params) {
    return requestService.get({
        methodName: '/Nom/ApprovalStatus',
        queryString: params
    });
}



function getPartners(params) {
    return requestService.get({
        methodName: '/Nom/Partners',
        queryString: params
    });
}



